<template>
  <div id="navbar-only">
    <vs-navbar
      class="topnavbar"
      back
      color
      text-color="red"
      active-text-color="red"
    >
      <div slot="title" class="themelogo">
        <img :src="logo" v-if="logo" alt="Dashboard" height="45px" />
        <!-- <span class="logo-text" v-if="title">{{ title }}</span> -->
      </div>

      <vs-dropdown vs-trigger-click class="cursor-pointer pr-2 pl-2 mr-1">
        <span>
          <icon-base
            viewBox="0 0 34 30"
            icon-name="Air-Condition"
            width="26"
            height="26"
            class="mode"
            ><icon-nine-dot
          /></icon-base>
          <!-- :iconColor="icon_nav_color" -->
        </span>
        <vs-dropdown-menu class="topbar-dd-gosite">
          <vs-dropdown-item href="https://demo.sitearound.com/" target="_blank">
            <div class="img-item">
              <img src="@/assets/images/sentenance/sar_logo_1.png" alt="" />
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
    <div style="padding: 90px 15px 0 15px">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("@/assets/images/logo/sentenance_logo.png"),
    };
  },
};
</script>

<style>
</style>